







































































import Vue from 'vue';
import axios from 'axios';
import { User, Role } from '@/types';
import { Utils } from '@/Utils';

interface Data {
    user?: User;
    Role: typeof Role;
}

export default Vue.extend({
    data(): Data {
        return {
            user: undefined,
            Role: Role
        };
    },
    methods: {
        beforeOpen(e) {
            this.user = e.params.user;
        },
        handleSave() {
            axios
                .put<User>(`${process.env.VUE_APP_API_URI}/api/admin/user/update`,
                    this.user
                )
                .then(res => {
                    this.user = res.data;
                    this.$modal.hide('editUser');
                })
                .catch(err => {
                    Utils.toastError('Something went wrong. Try again later.');
                });
        },
        promoteToManager(user) {
            axios
                .post(`${process.env.VUE_APP_API_URI}/api/admin/promote-user`, {
                    user: user.userName,
                })
                .then(res => {
                    user.roles = [...user.roles, Role.CampaignManager];

                    Utils.toastSuccess('User Promoted');
                })
                .catch(err => {
                    console.error(err);
                    Utils.toastError('Failed to promote user');
                });
        },
        demoteFromManager(user) {
            axios
                .post(`${process.env.VUE_APP_API_URI}/api/admin/demote-user`, {
                    user: user.userName,
                })
                .then(res => {
                    user.roles = user.roles.filter(
                        role => role != Role.CampaignManager
                    );

                    Utils.toastSuccess('Removed campaign creation permissions');
                })
                .catch(err => {
                    console.error(err);
                    Utils.toastError('Failed to demote user');
                });
        },
        revokeToken(user) {
            axios
                .post(`${process.env.VUE_APP_API_URI}/api/admin/revoke-token`, {
                    user: user.userName,
                })
                .then(res => {
                    Utils.toastSuccess('Token Revoked');
                })
                .catch(err => {
                    console.error(err);
                    Utils.toastError('Failed to revoke token');
                });
        },
    },
});
